import { forwardRef, useEffect, useState } from "react";
import ImageReaderFooter from "./footer";
import { separateNameAndFormat } from "../../../../../../../scripts/helpers";
import { authToken } from "../../../../../../storage/storage";
import heic2any from "heic2any";

const ImageReader = forwardRef(({ resource, scale, setScale }: any, ref: any) => {
    const [width, setWidth] = useState<number | string>(0);
    const [imageSrc, setImageSrc] = useState<any>("");

    useEffect(() => {
        if (separateNameAndFormat(resource.name).format === "heic") {
            const loadAndConvertImage = async () => {
                try {
                    const jpgDataUrl = await convertHeicUrlToJpg(resource.download_url);
                    setImageSrc(jpgDataUrl);
                    setWidth("100%");
                } catch (error) {
                    console.error("Error loading and converting HEIC image:", error);
                }
            };

            loadAndConvertImage();
        } else {
            const img = new Image();
            img.src = resource.download_url;
            img.onload = () => {
                if (img.width > window.innerWidth * 0.8) setWidth(800);
                else setWidth(img.width);
            };
        }
    }, [resource.download_url]);

    const convertHeicUrlToJpg = async (heicUrl: string) => {
        try {
            const heicResponse = await fetch(heicUrl, {
                headers: {
                    Authorization: `Bearer ${authToken.get()?.access}`
                }
            });
            const heicBlob = await heicResponse.blob();
            const jpgBlob = await heic2any({
                blob: heicBlob,
                toType: "image/jpeg"
            });
            const jpgDataUrl = URL.createObjectURL(jpgBlob as Blob);
            return jpgDataUrl;
        } catch (error) {
            console.error("Error converting HEIC URL to JPG:", error);
            return "";
        }
    };

    return (
        <>
            <div>
                <img
                    ref={ref}
                    src={separateNameAndFormat(resource.name).format === "heic" ? imageSrc : resource.download_url}
                    alt={resource.name}
                    style={{
                        width: width,
                        transform: `scale(${scale})`,
                        transition: "transform 0.3s ease-in"
                    }}
                    className={`m-auto object-contain max-h-[80vh]`}
                />

                {separateNameAndFormat(resource.name).format === "heic" && !imageSrc && <p>در حال بارگزاری ...</p>}
            </div>
            <ImageReaderFooter scale={scale} setScale={setScale} />
        </>
    );
});

export default ImageReader;
